import axios from 'axios';
import { API_URL } from '../config/api';

export const contentApi = {
	getActiveHero: async () => {
		const { data } = await axios.get(`${API_URL}/api/content/heroes/active/`);
		return data;
	},
	getActiveHeroes: async () => {
		const { data } = await axios.get(`${API_URL}/api/content/heroes/active_list/`);
		return data;
	},
	getTestimonials: async () => {
		const { data } = await axios.get(`${API_URL}/api/content/testimonials/`);
		// DRF puede devolver {results: [...]} o un array directo
		return Array.isArray(data) ? data : (data.results || []);
	},
	getPartners: async () => {
		const { data } = await axios.get(`${API_URL}/api/content/partners/`);
		// DRF puede devolver {results: [...]} o un array directo
		return Array.isArray(data) ? data : (data.results || []);
	},
	getProjectStatistics: async () => {
		const url = `${API_URL}/api/content/project-statistics/by_category/`;
		try {
			const { data } = await axios.get(url);
			return data;
		} catch (error) {
			throw error;
		}
	},
	getBlogPosts: async (category = null) => {
		const url = category 
			? `${API_URL}/api/content/blog/by_category/?category=${category}`
			: `${API_URL}/api/content/blog/published/`;
		const { data } = await axios.get(url);
		return data;
	},
	getBlogPost: async (slug) => {
		const { data } = await axios.get(`${API_URL}/api/content/blog/${slug}/`);
		return data;
	},
	incrementBlogViews: async (slug) => {
		const { data } = await axios.post(`${API_URL}/api/content/blog/${slug}/increment_views/`);
		return data;
	},
	searchBlogPosts: async (query) => {
		const { data } = await axios.get(`${API_URL}/api/content/blog/search/?q=${encodeURIComponent(query)}`);
		return data;
	},
	getRelatedBlogPosts: async (slug) => {
		const { data } = await axios.get(`${API_URL}/api/content/blog/${slug}/related/`);
		return data;
	},
	getServiceForms: async () => {
		// Obtener links de formularios desde SystemConfig
		const { data } = await axios.get(`${API_URL}/api/content/system-config/service_forms/`);
		return data;
	},
	updateServiceForms: async (formsData) => {
		// Actualizar links de formularios (requiere autenticación admin)
		const token = localStorage.getItem('authToken');
		if (!token) {
			throw new Error('No hay token de autenticación. Por favor, inicia sesión.');
		}
		const { data } = await axios.post(
			`${API_URL}/api/content/system-config/update_service_forms/`,
			formsData,
			{
				headers: {
					'Authorization': `Token ${token}`,
					'Content-Type': 'application/json'
				}
			}
		);
		return data;
	},
	getPlanPrices: async () => {
		// Obtener precios y avances de planes desde SystemConfig
		const { data } = await axios.get(`${API_URL}/api/content/system-config/plan_prices/`);
		return data;
	},
	updatePlanPrices: async (pricesData) => {
		// Actualizar precios y avances de planes (requiere autenticación admin)
		const token = localStorage.getItem('authToken');
		if (!token) {
			throw new Error('No hay token de autenticación. Por favor, inicia sesión.');
		}
		const { data } = await axios.post(
			`${API_URL}/api/content/system-config/update_plan_prices/`,
			pricesData,
			{
				headers: {
					'Authorization': `Token ${token}`,
					'Content-Type': 'application/json'
				}
			}
		);
		return data;
	},
	getEmpresasCarpetaData: async () => {
		const { data } = await axios.get(`${API_URL}/api/content/system-config/empresas_carpeta_data/`);
		return data;
	},
	updateEmpresasCarpetaData: async (payload) => {
		const token = localStorage.getItem('authToken');
		if (!token) {
			throw new Error('No hay token de autenticación. Por favor, inicia sesión.');
		}
		const { data } = await axios.post(
			`${API_URL}/api/content/system-config/update_empresas_carpeta_data/`,
			payload,
			{
				headers: {
					'Authorization': `Token ${token}`,
					'Content-Type': 'application/json'
				}
			}
		);
		return data;
	},

	getDocumentosConteos: async () => {
		const token = localStorage.getItem('authToken');
		const { data } = await axios.get(
			`${API_URL}/api/content/documentos-empresa-carpeta/conteos/`,
			{ headers: { 'Authorization': `Token ${token}` } }
		);
		return data;
	},

	getDocumentosEmpresa: async (empresaId) => {
		const { data } = await axios.get(
			`${API_URL}/api/content/documentos-empresa-carpeta/por-empresa/${empresaId}/`
		);
		return data;
	},

	getDocumentosEmpresaAdmin: async (empresaId) => {
		const token = localStorage.getItem('authToken');
		const { data } = await axios.get(
			`${API_URL}/api/content/documentos-empresa-carpeta/admin/por-empresa/${empresaId}/`,
			{ headers: { 'Authorization': `Token ${token}` } }
		);
		return data;
	},

	subirDocumentoEmpresa: async (formData) => {
		const token = localStorage.getItem('authToken');
		if (!token) {
			throw new Error('No hay token de autenticación. Por favor, inicia sesión.');
		}
		const { data } = await axios.post(
			`${API_URL}/api/content/documentos-empresa-carpeta/`,
			formData,
			{
				headers: {
					'Authorization': `Token ${token}`,
					'Content-Type': 'multipart/form-data',
				}
			}
		);
		return data;
	},

	eliminarDocumentoEmpresa: async (docId) => {
		const token = localStorage.getItem('authToken');
		if (!token) {
			throw new Error('No hay token de autenticación. Por favor, inicia sesión.');
		}
		await axios.delete(
			`${API_URL}/api/content/documentos-empresa-carpeta/${docId}/`,
			{ headers: { 'Authorization': `Token ${token}` } }
		);
	},

	actualizarDocumentoEmpresa: async (docId, payload) => {
		const token = localStorage.getItem('authToken');
		if (!token) {
			throw new Error('No hay token de autenticación. Por favor, inicia sesión.');
		}
		const { data } = await axios.patch(
			`${API_URL}/api/content/documentos-empresa-carpeta/${docId}/`,
			payload,
			{
				headers: {
					'Authorization': `Token ${token}`,
					'Content-Type': 'application/json',
				}
			}
		);
		return data;
	},
};

